export default "__VITE_ASSET__zBaQbq4D__"